let e=function(e){return e[e.RepeatOnAxis_X=0]="RepeatOnAxis_X",e[e.None=1]="None",e[e.RepeatOnAxis_Y=2]="RepeatOnAxis_Y",e}({});export{e as BackgroundImageRepeatType};
//# sourceMappingURL=IBanner.js.map
